import { Component, OnInit } from '@angular/core';
import { SearchResult } from 'src/app/shared';
import {
  CommCenter2ClaimsComponent,
  CommCenter2MessagesComponent,
  CommCenterService,
  TranslationService,
} from '../..';
import { InpageAliasService } from '../../services/inpage-alias.service';
import { Session } from '../../services/session.service';
import { ConversationSummary } from '../../models/ConversasationSummary';
import { TranslationRequest } from 'src/app/shared/models/translation/translation-request';
@Component({
    selector: 'app-comm-center2-page',
    template: ` <div>
      <app-section class="tw-w-full">
        <div class="app-pl2 tw-w-full">
          <app-claim-breadcrumb label=" Communication center" />
        </div>
        <app-panel
          title="Communication center"
          class="tw-w-full tw-min-h-[1000px]"
          [headerLevel]="1"
          [canExpand]="false"
          >
          <app-tab-group
            [hideSingleTab]="true"
            [tabGroupId]="'commCenterTabGroup'"
            >
            @if (showMyClaimsTab) {
              <app-tab
                label="my claims"
                [template]="myClaims"
                >
                <ng-template #myClaims>
                  @if(hasMyClaims) {
                    <div class="tw-pt-2"></div>
                    <app-comm-center2-claims
                      mode="MyClaims"
                (conversationSelected)="
                  myClaimsMessages.loadConversationMessages($event)
                "
                      #myCommCenterClaimsComp
                      [translationRequest]="translationRequest"
                      />
                      <h2 class="tw-w-full app-header-2 tw-pb-2 tw-pt-6">
                        {{'Conversation' | translation : translationRequest}}
                      </h2>
                      <app-comm-center2-messages
                        #myClaimsMessages
                (conversationUpdated)="
                  myCommCenterClaimsComp.loadConversations()
                "
                        [translationRequest]="translationRequest"
                        />
                      } @else {
                        <div class="tw-w-full tw-flex tw-justify-center tw-pt-12">
                          <app-empty-state-label
                            icon="list_alt"
                            header="{{'No claims' | translation:translationRequest}}"
                          ></app-empty-state-label>
                        </div>
                      }
                    </ng-template>
                  </app-tab>
                }
                @if (showEmployeeClaimsTab) {
                  <app-tab
                    [label]="employeeTabLabel"
                    [template]="employee"
                    >
                    <ng-template #employee>
                      <div class="tw-pt-4"></div>
                      <div [hidden]="searching">
                        <div class="tw-pt-2"></div>
                        <app-action-row>
                          <app-button
                            left1
                            autofocus
                            (click)="searching = true"
                            emphasis="High"
                            >{{'Select claim' | translation : translationRequest}}</app-button
                            >
                          </app-action-row>
                          <app-comm-center2-claims
                            mode="Manager"
                  (conversationSelected)="
                    employeeClaimsMessages.loadConversationMessages($event)
                  "
                            #managerClaims
                            />
                            <h2 class="tw-w-full app-header-2 tw-pb-2 tw-pt-6">
                              {{'Conversation' | translation : translationRequest}}
                            </h2>
                            <app-comm-center2-messages
                              #employeeClaimsMessages
                              (conversationUpdated)="managerClaims.loadConversations()"
                              />
                            </div>
                            <div [hidden]="!searching">
                              <app-action-row>
                                <a
                                  role="button"
                                  tabindex="0"
                                  left1
                                  (click)="searching = false"
                                  (keydown.enter)="searching = false"
                                  >{{'Return to messages' | translation : translationRequest}}</a
                                  >
                                </app-action-row>
                                <app-comm-center2-search
                  (selected)="
                    claimSelected($event, managerClaims, employeeClaimsMessages)
                  "
                                  />
                                </div>
                              </ng-template>
                            </app-tab>
                          }
                        </app-tab-group>
    
                        @if (session.user.leaveType === 'LeaveLink') {
                          <app-toast
                            type="Info"
                            class="tw-flex tw-justify-center"
                            >{{'LeaveLink claims will not be displayed in the Communication Center.' | translation : translationRequest}}
                          </app-toast>
                        }
                      </app-panel>
                    </app-section>
                  </div>`,
    styles: ``,
    standalone: false
})
export class CommCenter2PageComponent implements OnInit {
  searching = false;

  employeeTabLabel: string;

  showMyClaimsTab = false;

  showEmployeeClaimsTab = false;

  hasMyClaims = true;

  conversations: ConversationSummary[] = [];
  translationRequest = new TranslationRequest({
    language: '',
    key: null,
    contNum: 0,
    tableName: null,
    primaryKey: null,
    primaryValue: null,
    lob: null,
    group: 'Shared',
    subGroup: 'Shared',
  });


  constructor(
    public session: Session,
    private alias: InpageAliasService,
    public commCenterService: CommCenterService,
    public translationService : TranslationService
  ) {}

  loadTranslations(): void {
    this.translationRequest.language = sessionStorage.getItem('languagepreference');
    this.translationService.getTranslation(this.translationRequest);
  }

  async ngOnInit() {
    this.employeeTabLabel =
      (await this.alias.get('employeeSingular')) + ' claims';

    this.loadTranslations();
    // this logic might need to be adjusted for auditor
    this.showMyClaimsTab =
      !this.session.user.roles.controller && !this.session.isDelegating();
    this.showEmployeeClaimsTab =
      this.session.user.roles.controller || this.session.user.roles.manager;
    // this.hasMyClaims =
    //   (await this.commCenterService.getMyConversations())?.length > 0;

    const messagelst = (this.conversations =
      await this.commCenterService.getMyConversations());
    let message1 = messagelst;
    if (message1) {
      //this.session.user?.emulatorContext?.isEmulating &&
      message1 = messagelst.filter(
        (x) =>
          x.status?.toUpperCase().indexOf('CLOSE') === -1 ||
          x.details.length > 0
      );
    }
    this.hasMyClaims = message1?.length > 0;
  }

  async claimSelected(
    result: SearchResult,
    managerClaims: CommCenter2ClaimsComponent,
    employeeClaimsMessages: CommCenter2MessagesComponent
  ) {
    this.searching = false;
    employeeClaimsMessages.loadingState = 'Loading';
    await managerClaims.loadConversation(result);
  }
}
